<template>
    <div class="adminNav">
        <ul>
            <li>
                <font-awesome-icon icon="file"></font-awesome-icon> Product
                <ul>
                    <li><router-link :to="{name: 'admin_products_variant_new'}"><font-awesome-icon icon="plus-circle"></font-awesome-icon> New</router-link></li>
                    <li><router-link :to="{name: 'admin_products'}"><font-awesome-icon icon="list"></font-awesome-icon> List</router-link></li>
                    <li><router-link :to="{name: 'admin_products_color'}"><font-awesome-icon icon="palette"></font-awesome-icon> Colors</router-link></li>
                    <li><router-link :to="{name: 'admin_products_models'}"><font-awesome-icon icon="list"></font-awesome-icon> Models</router-link></li>
                    <li><router-link :to="{name: 'admin_products_bookmarks'}"><font-awesome-icon icon="bookmark"></font-awesome-icon> Bookmarks</router-link></li>
                </ul>
            </li>
            <li><router-link :to="{name: 'admin_hierarchy'}"><font-awesome-icon icon="sitemap"></font-awesome-icon> Hierarchy</router-link></li>
            <li><router-link :to="{name: 'admin_search'}"><font-awesome-icon icon="pen"></font-awesome-icon> Search Menu</router-link></li>
            <li>
                <font-awesome-icon icon="building"></font-awesome-icon> Brands
                <ul>
                    <li><router-link :to="{name: 'admin_brands'}"><font-awesome-icon icon="shopping-bag"></font-awesome-icon> Brands</router-link></li>
                    <li><router-link :to="{name: 'admin_brands_outdated'}" class="ssm-button-link"><font-awesome-icon icon="clock"></font-awesome-icon> Outdated</router-link></li>
                    <li><router-link :to="{name: 'admin_brands_marketplace'}"><font-awesome-icon icon="globe"></font-awesome-icon> Marketplaces</router-link></li>
                </ul>
            </li>
            <li>
                <font-awesome-icon icon="user"></font-awesome-icon> Users
                <ul>
                    <li><router-link :to="{name: 'admin_users'}"><font-awesome-icon icon="list-ul"></font-awesome-icon> List</router-link></li>
                    <li><router-link :to="{name: 'admin_users_new'}"><font-awesome-icon icon="plus-circle"></font-awesome-icon> New</router-link></li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "AdminNavBar"
    }
</script>

<style scoped lang="scss">
    .adminNav {
        width: 100%;
        background-color: var(--main-green);
        color: #FFF;
        margin-bottom: 30px;
        z-index: 9;

        a {
            color: #FFF;
            text-decoration: none;
        }

        ul {
            list-style: none;
            padding: 0;
        }

        & > ul {
            width: 80%;
            margin: auto;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            & > li {
                flex: 1;
                padding: 15px 40px;
                position: relative;
                box-sizing: border-box;
                text-align: center;

                &:not(:last-child) {
                    border-right: 1px solid #FFF;
                }

                i {
                    margin-right: 5px;
                }

                ul {
                    background-color: var(--main-green);
                    display: none;
                    position: absolute;
                    width: 100%;
                    top: 47px;
                    left: 0;
                    padding: 5px 10px;
                    text-align: center;
                    box-sizing: border-box;
                    border-radius: 0 0 5px 5px;
                }

                &:hover ul {
                    display: block;
                }

                ul li {
                    padding: 10px;
                    box-sizing: border-box;
                    border-top: 1px solid #FFF;
                }
            }
        }
    }

</style>
